/**
 * @name RouteWithLayout
 * @description Override react route with layout
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';

// React Router
import { Redirect, Route } from 'react-router-dom';

import { AuthService, PreviousRouteService } from '@services';

const RouteWithLayout = (props) => {
  const {
    layout: Layout,
    component: Component,
    auth,
    state,
    ...restProps
  } = props;

  return (
    <Route
      {...restProps}
      render={(routeProps) => (
        auth && !AuthService.hasActiveSession() ? (
          (() => {
            const routeToRedirect = PreviousRouteService.getRouteFromLocation(routeProps.location);
            PreviousRouteService.saveRouteFromExpiredSession(routeToRedirect);

            return (
              <Redirect
                to={{
                  pathname: '/login',
                  state: { from: routeProps.location }
                }}
              />
            );
          })()
        ) : state ? (
          <Layout {...state}>
            <Component {...routeProps} />
          </Layout>
        ) : (
          <Layout>
            <Component {...routeProps} />
          </Layout>
        )
      )}
    />
  );
};

RouteWithLayout.propTypes = {
  // Main layout.
  layout: PropTypes.any.isRequired,
  // Component.
  component: PropTypes.any.isRequired,
  auth: PropTypes.bool,
  state: PropTypes.object
};

RouteWithLayout.defaultProps = {
  auth: true
};

export default RouteWithLayout;
